import styled from 'styled-components';

import { theme } from '../../../../global';

export const Container = styled.div<{ $isSettings?: boolean }>`
  display: flex;
  width: ${({ $isSettings }) => $isSettings ? '100%' : '420px'};
height: 48px;
border-radius: 16px;
overflow: hidden;
border: 1px solid ${theme.colors.button_primary};

@media(max-width: 1358px) {
  width: 100%;
}
`;

export const Toggle = styled.div<{ $isActive?: boolean, $isCenter?: boolean }>`
position: relative;
flex: 1;
display: flex;
align-items: center;
justify-content: center;
color: ${theme.colors.button_primary};
font-weight: 600;
font-size: 14px;
line-height: 13px;
background-color: ${theme.colors.white};
cursor: pointer;
text-transform: uppercase;
transition:
font-weight 0.1s ease-in-out,
  background-color 0.1s ease-in-out,
    color 0.1s ease-in-out;

  ${({ $isActive }) =>
    $isActive &&
    `
    color: ${theme.colors.white};
    font-weight: 700;
    background-color: ${theme.colors.button_primary};
    `}

    ${({ $isCenter }) =>
    $isCenter &&
    `
    border-right: 1px solid ${theme.colors.button_primary};
    border-left: 1px solid ${theme.colors.button_primary};
    `}
`;
